import CryptoJS from 'react-native-crypto-js';
export default CryptoJS;
